// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3Nuro","upload":"Small_upload__1ma0a","imageWrap":"Small_imageWrap__2eTsU","removeBtn":"Small_removeBtn__3KUXM"};